<template>
  <div class="child-div">
    <div>
      <van-sticky>
        <van-search
          v-model="value"
          shape="round"
          readonly
          background="#F2F2F2"
          placeholder="请选择筛查条件"
          @click="showPicker()"
        />
      </van-sticky>
      <van-popup v-model="searchShow" position="top" round>
        <van-field
          v-model="dataForm.orgName"
          placeholder="请选择社区(村)"
          border
          label="社区(村)"
          name="name"
          @click="orgShow = true"
          readonly
        />
        <van-field v-model="dataForm.name" placeholder="请输入老人姓名" border label="老人姓名" name="name" />
        <van-field v-model="dataForm.idCard" placeholder="请输入老人身份证号" border label="身份证号" name="idCard" />
        <div style="display: flex;margin-bottom: 10px;justify-content: space-evenly;">
          <van-button
            @click="resetSubmit"
            class="buttonStyle"
            style="background-color: #ff976a;width: 47%;border-radius: 5px;"
            >重 置</van-button
          >
          <van-button
            @click="search"
            class="buttonStyle"
            style="width: 47%;border-radius: 5px;background-color: #1989fa;"
            >搜 索</van-button
          >
        </div>
      </van-popup>
      <van-popup v-model="orgShow" round position="bottom">
        <van-cascader
          v-model="dataForm.orgName"
          title="请选择社区(村)"
          :options="organList"
          @close="orgShow = false"
          @finish="onFinish"
          :field-names="{
            text: 'OrganName',
            value: 'OrganCode',
            children: 'Children',
          }"
        />
      </van-popup>
    </div>
    <div class="content">
      <van-list :loading="loading" :finished="finished" offset="0" @load="onLoadZh">
        <div class="list" v-for="(item, index) in oldManList" :key="index + 'aa'" @click="gotoDetail(item)">
          <div class="title">老人姓名：{{ item.Name }}</div>
          <div class="flex">
            <span>社区（村）：{{ item.OrgName }}</span>
          </div>
          <div class="flex">
            <span style="padding-right:10px">联系电话：{{ item.Tel }}</span>
            <span>年龄：{{ item.Age }}</span>
          </div>
          <div class="flex">
            <span>身份证号：{{ item.IDCard }}</span>
          </div>
          <div class="flex">
            <span style="padding-right:10px">联系人：{{ item.TouchMan }}</span>
            <span>联系电话：{{ item.TouchTel }}</span>
          </div>
          <div style="padding:5px 10px 10px" v-if="item.Address != null">住址：{{ item.Address }}</div>
          <div style="padding:5px 10px 10px" v-else>住址：</div>
        </div>
      </van-list>
    </div>

    <van-button class="button" @click="add()"><van-icon name="plus" style="font-size: 20px;"/></van-button>
    <div>
      <van-tabbar v-model="active" @change="onChangeTab" active-color="#0f97ff" inactive-color="#000">
        <van-tabbar-item icon="home-o" name="home">首页</van-tabbar-item>
        <!-- <van-tabbar-item icon="orders-o" name="orders">服务工单</van-tabbar-item> -->
        <van-tabbar-item icon="friends-o" name="contact">老人档案</van-tabbar-item>
        <!-- <van-tabbar-item icon="manager-o">我的</van-tabbar-item> -->
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { getwgToken, setwgToken } from '@/utils/auth'
import { WeGetOrganTree, GetOldManPage } from '@/api/Organ'
import { Dialog } from 'vant'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  data() {
    return {
      active: 'contact',
      value: '',
      searchShow: false,
      dataForm: {
        name: '',
        idCard: '',
        orgName: '',
        orgCode: '',
        page: 0,
        limit: 10,
      },
      organList: [],
      orgShow: false,
      oldManList: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      total: undefined, //数据条数
    }
  },
  mounted() {
    this.getOrganList()
    this.getOldManList()
  },
  methods: {
    // 顶部筛查条件弹窗
    showPicker() {
      this.searchShow = true
    },
    // 点击社区
    onFinish(val) {
      // console.log(val)
      this.fieldValue = val.selectedOptions.map((option) => option.OrganName).join('/')
      this.dataForm.orgName = this.fieldValue
      this.dataForm.orgCode = val.value
      this.orgShow = false
    },
    // 获取社区村
    getOrganList() {
      WeGetOrganTree({ level: 4, kind: 1 }).then((res) => {
        this.organList = res.data.data
      })
    },
    // 重置搜索表单
    resetSubmit() {
      this.dataForm = {
        name: '',
        idCard: '',
        orgName: '',
        orgCode: '',
        page: 1,
        limit: 10,
      }
    },
    // 搜索
    search() {
      this.dataForm.page = 1
      this.oldManList = []
      this.searchShow = false
      this.getOldManList()
    },
    // 获取老人信息
    getOldManList() {
      // this.dataForm.accToken = getwgToken();
      // this.organList = []
      GetOldManPage(this.dataForm)
        .then((res) => {
          let rows = res.data.data //请求返回当页的列表
          // 加载状态结束
          this.loading = false

          if (res.data.code == 0) {
            if (rows == null || rows.length === 0) {
              // 加载结束
              this.finished = true
              return
            }
            // 将新数据与老数据进行合并
            this.oldManList = this.oldManList.concat(rows)

            //如果列表数据条数>=总条数，不再触发滚动加载
            if (this.oldManList.length >= res.data.count) {
              this.finished = true
            }
          } else if (res.data.code == 401) {
            Toast('用户未登录请重新登录')
            if (window.__wxjs_environment === 'miniprogram') {
              window.wx.miniProgram.redirectTo({
                url: 'pages/admin/adminLogin/adminLogin',
              })
            } else {
              alert('请在小程序中打开')
            }
          } else {
            Toast(res.data.msg)
          }
        })
        .catch(() => {})
    },

    // 编辑老人信息
    gotoDetail(val) {
      this.$router.push('/adminHome/oldManList/oldManDetail/1/' + val.OMId)
    },
    add() {
      this.$router.push('/adminHome/oldManList/oldManDetail/0/0')
    },
    onLoadZh() {
      this.dataForm.page = this.dataForm.page + 1
      this.getOldManList()
    },
    // 底部导航栏切换
    onChangeTab: function(row) {
      console.log(row)
      if (row == 'home') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../../admin/adminH5/home?path=/adminHome/home',
          })
        } else {
          alert('请在小程序中打开')
        }
        // this.$router.push({
        //   path: "/ylOrder/orderList",
        // });
      } else if (row == 'orders') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../../admin/adminWorkOrderAll/adminWorkOrderAll',
          })
        } else {
          alert('请在小程序中打开')
        }
      } else if (row == '2') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../../admin/adminMy/adminMy',
          })
        } else {
          alert('请在小程序中打开')
        }
      } else if (row == 'contact') {
        // if (window.__wxjs_environment === "miniprogram") {
        //   window.wx.miniProgram.redirectTo({
        //     url: "../../admin/oldManList/index",
        //   });
        // } else {
        //   alert('请在小程序中打开')
        // }
        // this.$router.push({
        //   path: '/adminHome/oldManList',
        // })
      }
    },
  },
}
</script>
<style scoped>
.list {
  position: relative;
  width: 94%;
  margin: 10px 3% 0px;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  color: #333;
  box-shadow: 0 0 5px #dadada;
}
.list .title {
  padding: 5px 10px;
  font-weight: 700;
  font-size: 15px;
  color: #000;
  letter-spacing: 2px;
}
.list .flex {
  display: flex;
  font-size: 12px;
  color: #333;
  padding: 5px 10px;
}

/* 按钮 */
.button {
  width: 50px;
  height: 50px;
  /* line-height: 50px; */
  /* margin: 10px 10%; */
  background: #3296fa;
  color: #fff;
  border: 1px solid #3296fa;
  border-radius: 50px;
  position: fixed;
  bottom: 95px;
  right: 25px;
}
</style>
